import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AppConfigService } from '../app-config.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { GalleryService } from '../services/gallery.service';
import { CommonService } from '../common.service';
import { LoginPopupComponent } from '../login/login-popup/login-popup.component';
import { OAuthService } from 'angular-oauth2-oidc';
import { of } from 'rxjs';


@Component({
  selector: 'app-web-viewer-frame',
  templateUrl: './web-viewer-frame.component.html',
  styleUrls: ['./web-viewer-frame.component.less']
})
export class WebViewerFrameComponent implements OnInit {
  urlSafe: SafeResourceUrl | undefined;
  id: string = '';
  appConfig: any = {};

  constructor(private readonly sanitizer: DomSanitizer,
    private readonly appConfigService: AppConfigService,
    private readonly dialog: MatDialog,
    private readonly router: Router,
    private readonly authService: AuthService,
    private readonly ouathService: OAuthService,
    private readonly galleryService: GalleryService,
    private readonly commonService: CommonService) {
    this.appConfig = this.appConfigService.config;
    this.registerMessageEvent();
  }

  registerMessageEvent() {
    const msgEvent = (event: any) => {
      if ((event?.data?.call == 'parentComponent') && event?.data?.value?.fetchSlideInfo) {
        if (event?.data?.value?.fetchSlideInfo) {
          this.commonService.fetchProjectLSData();
        }
        this.sendDataToViewer(event?.data?.value?.postMessageCall);
      } else if (event?.data?.call == 'viewerInitialized') {
        this.commonService.ProjectLSData['isViewerInitialized'] = true;
        this.commonService.setProjectLSData();
      } else if (event?.data?.call == 'updateViewerInfo') {
        let slidesInfo: any = event?.data?.value?.slidesInfo;
        this.commonService.ProjectLSData['ViewerSlides'] = slidesInfo;
        this.commonService.setProjectLSData();
      } else if (event?.data?.call == 'openImageInSameViewer') {
        let slidesInfo: any = event?.data?.value?.slidesInfo;
        this.commonService.ProjectLSData['ViewerSlides'] = slidesInfo;
        if (event?.data?.value?.mrnId) {
          this.commonService.ProjectLSData['MRNID'] = event.data.value.mrnId;
        }
        this.commonService.setProjectLSData();
        this.updateViewerImage('updateViewerImageInfo', {
          ViewerSlides: this.commonService.ProjectLSData['ViewerSlides'],
          newSlideIndex: event.data.value['newSlideIndex']
        });
      } else if (event?.data?.call == 'compareImageViewerUpdate') {
        let slidesInfo: any = event?.data?.value?.slidesInfo;
        if (event?.data?.value?.saveData) {
          this.commonService.ProjectLSData['ViewerSlides'] = slidesInfo;
          if (event?.data?.value?.mrnId) {
            this.commonService.ProjectLSData['MRNID'] = event.data.value.mrnId;
          }
          this.commonService.setProjectLSData();
        }
        this.updateViewerImage('updateCompareViewerImageInfo', {
          ViewerSlides: slidesInfo,
          slideIds: event?.data?.value?.slideIds,
          viewerUpdateInfo: event?.data?.value?.viewerUpdateInfo
        });
      } else if (event?.data?.call == 'compareImage') {
        this.commonService.ProjectLSData['ViewerSlides'] = event?.data?.value?.slidesInfo;
        if (!this.commonService.ProjectLSData['primaryFilter']) {
          this.commonService.ProjectLSData['primaryFilter'] = { ...this.commonService.ProjectLSData['galleryFilters'] };
          this.commonService.ProjectLSData['galleryFilters']['viewByG'] = event?.data?.value?.compareActive ? '1' : this.commonService.ProjectLSData['galleryFilters']['viewByG'];
          this.commonService.ProjectLSData['galleryFilters']['selectedAccordion'] = event?.data?.value?.compareActive ? event?.data?.value?.slidesInfo[0]?.animal?.dosageCode : this.commonService.ProjectLSData['galleryFilters']['selectedAccordion'];
        } else if (this.commonService.ProjectLSData['primaryFilter'] && event?.data?.value?.compareActive) {
          this.commonService.ProjectLSData['galleryFilters']['viewByG'] = '1';
          this.commonService.ProjectLSData['galleryFilters']['selectedAccordion'] = event?.data?.value?.slidesInfo[0]?.animal?.dosageCode;
        } else {
          this.commonService.ProjectLSData['galleryFilters'] = { ...this.commonService.ProjectLSData['primaryFilter'] };
          delete this.commonService.ProjectLSData['primaryFilter'];
        }
        this.commonService.ProjectLSData['unselectedFromCompare'] = [];
        this.commonService.setProjectLSData();
        this.router.navigate(['WebViewer']).then(() => {
          this.sendDataToViewer();
        });
      } else if (event?.data?.call == 'updateSlideReview') {
        if (event?.data?.value?.slideReviewData) {
          event.data.value.slideReviewData['type'] = this.commonService.ProjectLSData['userActivePlace'].startsWith("study") ? 'STUDY' : 'PROJECT';
          event.data.value.slideReviewData['slideReviewData']['type'] = this.commonService.ProjectLSData['userActivePlace'].startsWith("study") ? 'STUDY' : 'PROJECT';
          event.data.value.slideReviewData['slideReviewData']['organReviewPk'] = event.data.value.slideReviewData?.organReviewPk
        }
      } else if (event?.data?.call == 'saveSlideReview') {
        if (event?.data?.value?.slideReviewData) {
          event.data.value.slideReviewData['type'] = this.commonService.ProjectLSData['userActivePlace'].startsWith("study") ? 'STUDY' : 'PROJECT'
          event.data.value.slideReviewData['slideReviewData']['type'] = this.commonService.ProjectLSData['userActivePlace'].startsWith("study") ? 'STUDY' : 'PROJECT'
        }
      } else if (event?.data?.call == 'fetchParentLoginToken') {
        this.fetchParentLoginToken();
      } else if (event?.data?.call == 'moveToGallery') {
        delete this.commonService.ProjectLSData['ViewerSlides'];
        this.commonService.setProjectLSData();
        this.moveToGallery(msgEvent);
      } else if (event?.data?.call == 'updateCompareselection') {
        this.commonService.ProjectLSData["unselectedFromCompare"] = event?.data?.value?.unselected;
        this.commonService.setProjectLSData();
      } else if (event?.data?.call == 'emptyUnselectedCompare') {
        delete this.commonService.ProjectLSData["unselectedFromCompare"];
        this.commonService.setProjectLSData();
      } else if (event?.data?.call === 'updateViewerSlides') {
        this.commonService.ProjectLSData['ViewerSlides'] = event.data.value.viewerSlides;
        this.commonService.setProjectLSData();
      } else if (event?.data?.call === 'saveSlideTrayFilterData') {
        this.commonService.ProjectLSData['slideTrayFilterData'] = event.data.value.slideTrayFilterData;
        this.commonService.setProjectLSData();
      } else if (event?.data?.call == 'reLogin') {
        this.reLogin();
      } else if (event?.data?.call == 'fetchRefreshToken') {
        this.refreshToken();
      }
    }
    window.addEventListener("message", msgEvent, false);
  }

  ngOnInit(): void {
    this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.appConfig?.webViewerUrl);
  }

  updateViewerImage(iFrameCall: any, callValue: any) {
    let iframe: any = document.getElementById('webViewerFrame');
    iframe['contentWindow'].postMessage({
      call: iFrameCall, value: callValue
    }, this.appConfig?.webViewerUrl);
  }

  fetchParentLoginToken() {
    console.log("fetchParentLoginToken");
    if (localStorage[this.commonService.projectName]) {
      this.commonService.ProjectLSData = JSON.parse(localStorage[this.commonService.projectName]);
    }
    let fetchParentLoginTokenObj: any = {
      accessToken: this.commonService.ProjectLSData.accessToken,
      refreshToken: this.commonService.ProjectLSData.refreshToken,
      sessionId: this.commonService.ProjectLSData.sessionId
    };
    let iframe: any = document.getElementById('webViewerFrame');
    iframe['contentWindow'].postMessage({
      call: 'fetchParentLoginTokenSuccess', value: fetchParentLoginTokenObj
    }, this.appConfig?.webViewerUrl);
  }

  refreshToken() {
    let refreshTokenApi = this.commonService.ProjectLSData['isGuestLogin'] ? of(this.ouathService.getRefreshToken()) : this.authService.refreshToken();
    refreshTokenApi.subscribe((tokens: any) => {
      let refreshTokenObj: any = {
        accessToken: this.commonService.ProjectLSData['accessToken'],
        refreshToken: this.commonService.ProjectLSData['refreshToken'],
        sessionId: this.commonService.ProjectLSData['sessionId']
      }
      this.fetchParentLoginToken();
      let iframe: any = document.getElementById('webViewerFrame');
      iframe['contentWindow'].postMessage({
        call: 'latestRefreshToken', value: refreshTokenObj, success: true
      }, this.appConfig?.webViewerUrl);
    }, error => {
      this.reLogin(true);
    });
  }

  reLogin(isRefreshToken: boolean = false) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      headerTitle: "Login",
      confirmMsg: "Session expired. Login again to continue",
      cancelButtonText: "Cancel",
      confirmButtonText: "Yes",
      isAccessTokenExpired: true,
      location: 'viewer'
    };
    const dialogref = this.dialog.open(LoginPopupComponent, dialogConfig);
    return dialogref.afterClosed().subscribe((result: any) => {
      if (result) {
        let reLoginObj: any = {
          accessToken: this.commonService.ProjectLSData['accessToken'],
          refreshToken: this.commonService.ProjectLSData['refreshToken'],
          sessionId: this.commonService.ProjectLSData['sessionId']
        };
        this.fetchParentLoginToken();

        let iframe: any = document.getElementById('webViewerFrame');
        iframe['contentWindow'].postMessage({
          call: (isRefreshToken ? "latestRefreshToken" : "reLoginSuccess"), value: reLoginObj
        }, this.appConfig?.webViewerUrl);
      }
    });
  }

  moveToGallery(msgEvent: any) {
    window.removeEventListener("message", msgEvent, false);
    if (this.commonService.ProjectLSData['parentInfo']?.['isOpenFromProjects']) {
      delete (this.commonService.ProjectLSData['parentInfo']?.['isOpenFromProjects']);
    }

    if (this.appConfig?.webAppConfig?.openViewer == "popup") {
      window.close();
    } else {
      this.router.navigate([this.commonService.ProjectLSData.LastParentAppUrl.replace(this.appConfig?.parentAppUrl + this.appConfig?.replacePathName, '')]);
    }
  }

  sendDataToViewer(postMessageCall: any = null) {
    let iframe: HTMLIFrameElement = <HTMLIFrameElement>document.getElementById('webViewerFrame')!;
    if (iframe == null) return;
    let windowObj = {
      parentProj: 'SlideQualityControl',
      viewerOpenedFrom: this.commonService.ProjectLSData.viewerOpenedFrom ? this.commonService.ProjectLSData.viewerOpenedFrom : 'gallery',
      activeRole: this.commonService.ProjectLSData.userActiveRole,
      loginUrl: this.appConfig?.parentAppUrl,
      parentInfo: this.commonService.ProjectLSData['parentInfo'] ? this.commonService.ProjectLSData['parentInfo'] : {},
      viewerBaseName: this.appConfig?.viewerBaseName,
      urlParent: {
        "apiUrl": this.appConfig?.apiUrl,
        "thumbnailUrl": this.appConfig?.thumbnailUrl,
        "tileUrl": this.appConfig?.tileUrl,
        "schemaUrl": this.appConfig?.schemaUrl
      },
      viewerSlides: this.commonService.ProjectLSData['ViewerSlides'],
      lastParentAppUrl: this.commonService.ProjectLSData['LastParentAppUrl'],
      parentUrl: JSON.stringify(this.commonService.ProjectLSData['UrlApi']),
      currentUser: this.commonService.ProjectLSData['currentUser'],
      anonymisedLabel: this.appConfig?.galleryConfig?.anonymisedLabel,
      WebViewerOpenType: this.appConfig?.openViewer,
      accessToken: this.commonService.ProjectLSData['accessToken'],
      refreshToken: this.commonService.ProjectLSData['refreshToken'],
      sessionId: this.commonService.ProjectLSData['sessionId'],
      subjectIdPrefix: this.appConfig?.subjectIdPrefix,
      unselectedFromCompare: this.commonService.ProjectLSData['unselectedFromCompare'],
      slideTrayFilterData: this.commonService.ProjectLSData?.slideTrayFilterData,
      appCode: "SlideQualityControl",
      appVersion: this.commonService.ProjectLSData.appVersion,
      showAppVersion: this.appConfig.showAppVersion,
      dashboardInfo: this.commonService.ProjectLSData?.dashboardInfo || {},
      isGuestLogin: this.commonService.ProjectLSData['isGuestLogin'],
      tissueMissingBoxColor: this.appConfig?.tissueMissingBoxColor
    }
    iframe?.['contentWindow']?.postMessage({
      call: (postMessageCall || 'webViewerFrame'), value: windowObj
    }, this.appConfig?.webViewerUrl);
  }

}
